import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogOverlay,
} from '@/components/ui/dialog';

interface ModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: string;
  children: React.ReactNode;
  description?: string;
  style?: string | boolean;
  closeBtn?: React.ReactNode;
  bgBlur?: boolean;
}

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  style,
  closeBtn,
  bgBlur = false,
}: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {bgBlur && <DialogOverlay className="bg-transparent backdrop-blur-[5px]" />}

      <DialogContent
        className={`max-w-xl bg-modal-gredient mt-3 top-0 !translate-y-0 p-0 ${style} [&>button.absolute]:hidden`}
      >
        {(title || closeBtn) && (
          <DialogHeader className="sticky top-0 z-10 flex flex-row items-center justify-between border-b border-green3 bg-modal-gredient p-4 text-textcolor">
            <div>
              <DialogTitle className="text-xl font-semibold">{title}</DialogTitle>

              {description && (
                <DialogDescription className="text-gray-500">{description}</DialogDescription>
              )}
            </div>

            {closeBtn && (
              <div onClick={() => onOpenChange?.(false)} className="cursor-pointer flex-shrink-0">
                {closeBtn}
              </div>
            )}
          </DialogHeader>
        )}

        {/* Only this part scrolls */}
        <div className="max-h-[calc(80dvh-70px)] overflow-y-auto p-4">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
